module.exports = __webpack_public_path__ + "static/img/liyade4.144818cd.jpg";